// Ask the file server for a smaller copy of our own uploads (200 / 600 / 1600px).
export const thumb = (url, w) =>
    typeof url === "string" && url.includes("/api/files/") && !url.includes("?") ? `${url}?w=${w}` : url;
